import { useNavigate } from 'react-router-dom';

import { sendReceiptByEmail } from 'api/Transaction';

import { useUIContext } from 'lib/context/UIContext/UIContext';
import useModal from 'lib/hooks/useModal';

import { showAlert } from 'components/shared/Alert/Alert';
import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';
import ReceiptModal from 'components/shared/Receipt/ReceiptModal';
import Typography from 'components/shared/Typography/Typography';

const SuccessPayment = ({ transactionId, isKiosk }) => {
  const { isOpen, openModal, closeModal } = useModal();
  const navigate = useNavigate();
  const { device } = useUIContext();

  const emailReceipt = async () => {
    try {
      const res = await sendReceiptByEmail(navigate, { transactionId });
      if (res?.code === 0) {
        showAlert({
          color: 'success',
          title: 'Receipt Emailed',
          position: device === 'laptop' || device === 'desktop' ? 'top-right' : 'bottom-right'
        });
      } else {
        showAlert({
          color: 'danger',
          title: 'Failed to email receipt. Please try again later.',
          position: device === 'laptop' || device === 'desktop' ? 'top-right' : 'bottom-right'
        });
      }
    } catch (error) {
      showAlert({
        color: 'danger',
        title: 'Failed to email receipt. Please try again later.',
        position: device === 'laptop' || device === 'desktop' ? 'top-right' : 'bottom-right'
      });
    }
  };

  return (
    <div className="fixed inset-0 h-screen w-screen overflow-hidden p-10">
      <Icon
        icon="bg-pattern"
        className="absolute inset-0 h-full w-full [&>div]:absolute [&>div]:inset-0 [&>div]:h-full [&>div]:w-full"
      />
      <div className="relative flex h-full w-full flex-col items-center justify-center gap-3">
        <div className="flex flex-col items-center justify-center">
          <Icon icon="illustration-payment-successful" size={160} />
          <Typography variant="p" size="medium" weight="medium">
            Payment successful!
          </Typography>
          <Typography variant="p" size="small" color="neutral-700">
            The payment was processed successfully.
          </Typography>
        </div>
        <div className="flex min-w-[280px] flex-col items-center justify-center gap-2">
          <div className="mt-3 flex w-full items-center gap-2 sm:flex-col">
            <Button
              text="View receipt"
              icon="receipt-1-mono"
              variant="tertiary"
              size="small"
              color="neutral"
              textClassName="whitespace-nowrap"
              wrapperClassName="w-full"
              className="w-full"
              onClick={openModal}
            />
            <Button
              text="Email receipt"
              icon="mail-mono"
              variant="tertiary"
              color="neutral"
              size="small"
              wrapperClassName="w-full"
              className="w-full"
              textClassName="whitespace-nowrap"
              onClick={emailReceipt}
            />
          </div>
          <Button
            text="Close"
            variant="tertiary"
            size="small"
            wrapperClassName="w-full"
            className="w-full"
            onClick={() => navigate(isKiosk ? '/kiosk/idle' : '/')}
          />
        </div>
      </div>
      {isOpen && (
        <ReceiptModal transactionId={transactionId} isOpen={isOpen} onClose={closeModal} />
      )}
    </div>
  );
};

export default SuccessPayment;
